import React from "react";
import { Tooltip } from "@panwds/react-ui";
import { InfoIcon } from "@panwds/icons";
import dayjs, { getLocalBrowserTimeZone } from "../utils/date";
import { getUtcToday } from "../utils/calendarDay";

/**
 * Tells the user that day boundaries on this surface are UTC days, and (on hover) how that
 * relates to their own time zone, so a cell that looks like "tomorrow" or "yesterday" is explained.
 */
const UtcNotice = ({ className = "" }) => {
    const tooltip = `Your time zone: ${getLocalBrowserTimeZone()} (UTC${dayjs().format("Z")}). Today in UTC: ${getUtcToday()}.`;

    return (
        <Tooltip label={tooltip} defaultPlacement="top">
            <span
                data-testid="utc-notice"
                className={`ssmutw-inline-flex ssmutw-items-center ssmutw-gap-1 ssmutw-text-xs ssmutw-text-ssmu-text-tertiary ssmutw-select-none ${className}`}
            >
                <InfoIcon size="sm" aria-hidden="true" />
                Dates shown in UTC
            </span>
        </Tooltip>
    );
};

export default UtcNotice;
